import { useEffect } from 'react';
import { PrinterSettingContent } from './PrinterSettingContent';

interface PrinterSettingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PrinterSettingModal = ({ isOpen, onClose }: PrinterSettingModalProps) => {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      return () => document.removeEventListener('keydown', handleEsc);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex justify-center items-center p-4">
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
        aria-hidden
      />
      <div
        className="relative flex flex-col bg-white rounded-lg shadow-xl w-full max-w-3xl min-h-[70vh] max-h-[95vh] overflow-hidden border border-gray-200"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-end flex-shrink-0 px-3 py-2 border-b border-gray-200 bg-white">
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 rounded hover:bg-gray-100 text-gray-500 hover:text-gray-700 text-lg leading-none"
            title="닫기"
          >
            ✕
          </button>
        </div>
        <div className="overflow-auto flex-1 min-h-0">
          <PrinterSettingContent onClose={onClose} />
        </div>
      </div>
    </div>
  );
};
